

define(['angular', 'squid/index', 'text!./template.html', 'components/xo-ui-components/src/error-tooltip/directive'], function (angular, squid, template) {
    return angular.module('xo-zipcode.directive', ['squid', 'xo-error-tooltip.directive']).directive('xoZipcode', function () {
        return {
            template: template,
            scope: {
                country: '@',
                zipLabel: '@',
                postalCodeLabel: '@',
                zipErrorText: '@',
                doneFn: '=',
                zipCode: '=',
                zipEntry: '=',
                maxLength: '='
            },

            controller: function controller($scope, $feature) {
                var formatRegex;
                var inputParams = $feature('zipcodeInputParams', undefined, $scope.country);
                if (inputParams) {
                    $scope.minLength = inputParams.minLength;
                    $scope.maxLength = inputParams.maxLength;
                    if (inputParams.formatPattern) {
                        formatRegex = new RegExp(inputParams.formatPattern, 'g');
                    }
                }

                function formatZipWithDash(zipcode, index) {
                    if (zipcode.length > index) {
                        zipcode = [zipcode.slice(0, index), '-', zipcode.slice(index)].join('');
                    }
                    return zipcode;
                }

                $scope.changeZip = function (zipcode) {
                    if (zipcode) {

                        if (formatRegex) {
                            zipcode = zipcode.replace(formatRegex, '');
                        }

                        if (inputParams && inputParams.formatZip) {
                            zipcode = formatZipWithDash(zipcode, inputParams.minLength);
                        }

                        $scope.zipCode = zipcode;
                    }
                };

                $scope.doneFunction = function () {
                    if ($scope.doneFn) {
                        $scope.doneFn();
                    }
                };
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-form-components/src/zipcode/directive.js
 ** module id = 290
 ** module chunks = 1
 **/